import { render } from "./MaskCare.vue?vue&type=template&id=42282bc4&scoped=true"
import script from "./MaskCare.vue?vue&type=script&lang=js"
export * from "./MaskCare.vue?vue&type=script&lang=js"

import "./MaskCare.vue?vue&type=style&index=0&id=42282bc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42282bc4"]])

export default __exports__